/** Sidebar user shape used by {@link Layout}. */
export type LayoutSidebarUser = {
  name: string;
  email: string;
  role: string;
  tenant: string;
};

let authChecked = false;
let cachedUser: LayoutSidebarUser | null = null;

export function getLayoutAuthCache(): { checked: boolean; user: LayoutSidebarUser | null } {
  return { checked: authChecked, user: cachedUser };
}

export function setLayoutAuthCache(user: LayoutSidebarUser | null): void {
  authChecked = true;
  cachedUser = user;
}

export function clearLayoutAuthCache(): void {
  authChecked = false;
  cachedUser = null;
}

export function readLayoutUserFromStorage(): LayoutSidebarUser | null {
  if (typeof window === 'undefined') return null;
  const userStr = localStorage.getItem('user');
  if (!userStr) return null;
  try {
    const userData = JSON.parse(userStr) as {
      firstName?: string;
      lastName?: string;
      email?: string;
      role?: string;
      tenantId?: string;
    };
    return {
      name: `${userData.firstName ?? ''} ${userData.lastName ?? ''}`.trim(),
      email: userData.email ?? '',
      role: userData.role ?? '',
      tenant: userData.tenantId ?? '',
    };
  } catch {
    return null;
  }
}
